module.exports =
  '_PROFILE':
    'TITLE_PREVIEW': 'Profile public screen preview'
    'TITLE': 'Profile'
    'BIRTH_DATE': 'Birthday'
    'GENDER': 'Gender'
    'MALE': 'Male'
    'FEMALE': 'Female'
    'COUNTRY': 'Country'
    'RECENT_ROUNDS': 'Total round count'
    'BEST_SCORE': 'Best score'
    'AVG_SCORE': 'Avg score'
    'SCORE_THIS_YEAR': "This year's score"
    'TOP_5_HEADING': 'Frequently used golf courses TOP 5'
    'LATEST_ROUNDS': 'Recent round info'
    'SEE_MORE': 'See more'
    'PHOTOS_HEADING': 'Photo scorecard'
    'CLUB_SETTING': 'Clubset'
    'USE_BALL': 'Use ball'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/profile/i18n/en.coffee